import componentConfig from "@voxmedia/duet-ui/components/brand/theverge/config/component.config";
import { mergeProps } from "@voxmedia/duet-ui/utils/merge-props";

import { cskNavigationConfig } from "./csk-navigation.config";

/** Verge component config with CSK story-shell navigation defaults. */
const cskComponentConfig = mergeProps(componentConfig, {
  navigation: cskNavigationConfig,
});

export default cskComponentConfig;
